var exports = {
  "k": "x93eb46d8--dc113c--container",
  "Q": "x93eb46d8--dc113c--text",
};

module.exports = exports;
